import { StateCreator } from 'zustand';
import { FeedbackData, FeedbackState } from '../types';
export interface FeedbackActions {
  postFeedback: (data: FeedbackData, url: string) => Promise<void>;
  resetForm: () => void;
  setFormField: <K extends keyof FeedbackData>(
    field: K,
    value: FeedbackData[K],
  ) => void;
}

export const createFeedbackActions: StateCreator<
  FeedbackState & FeedbackActions,
  [],
  [],
  FeedbackActions
> = (set, get) => ({
  postFeedback: async (data: FeedbackData, url: string) => {
    try {
      set({ isLoading: true, error: null, success: false });
      await fetch('/api/send_feedback', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify( { ...data, url } )
      });
      set({ success: true, isLoading: false });
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || error.message;
      set({ error: errorMessage, isLoading: false, success: false });
      alert(errorMessage);
      throw error;
    }
  },

  resetForm: () => {
    set({
      formData: {
        full_name: '',
        company_name: '',
        phone_number: '',
        email: '',
        company_specialization: '',
        details: '', 
      },
      error: null,
      success: false,
    });
  },

  setFormField: (field, value) => {
    set((state) => ({
      formData: { ...state.formData, [field]: value },
    }));
  },
});
